import Qs from 'querystring'

const urlParams = Qs.parse(window.location.search.substr(1))

const renderBgimage = (d, isSuWebp) => {
    if (d.imageType && d.imageType !== 'image') {
        return d.image
    }
    if ([undefined, 'image'].includes(d.imageType) && d.image) {
        if (isSuWebp && d.image.indexOf('pics/') > -1) {
            const url = (d.image.includes('www-ecs') ? 'https://www-ecs.didapinche.com/pics/' : 'https://web-static.didachuxing.com/pics/') + d.image.split('pics/').pop()
            return `url('${url.replace(/\.(jpg|png|gif)/, '.webp')}')`
        }
        return `url(${d.image})`
    }
    return 'none'
}

export const renderBg = (d = {}, isSuWebp) => ({
    'backgroundColor': d.color,
    'backgroundImage': renderBgimage(d, isSuWebp),
    'backgroundRepeat': d.repeat,
    'backgroundSize': d.size || 'cover',
    'backgroundPosition': d.position || 'top center',
    'backgroundOrigin': d.origin
})

export const addScript = (url) => {
    const wb = document.createElement('script')
    const s = document.getElementsByTagName('script')[0]
    wb.type = 'text/javascript'
    wb.async = false
    wb.src = url
    return new Promise((resolve) => {
        // eslint-disable-next-line no-multi-assign
        wb.onload = wb.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                resolve()
            }
        }
        s.parentNode.insertBefore(wb, s)
    })
}

/**  根据Href参数获取值 */
const getValueByHref = (params) => urlParams[params] || ''

/**
 * 根据参数 获取window值
 */
const getValueByWindow = (params) => {
    const prevObj = params.reduce((prev, next) => {
        let getVal
        if (window[next]) {
            getVal = window[next] || ''
        } else {
            getVal = (prev && prev[next]) || ''
        }
        return getVal
    }, null)
    return prevObj
}

/**
 * 从cookie里面获取
 */
const cookieGet = (key) => document.cookie.split('; ')
    // eslint-disable-next-line prefer-template
    .find((cookie) => cookie.startsWith(key + '='))
    ?.split('=')[1] || ''

/** 获取模版字符串对应的对象值 */
export const getTypeValue = (link = '') => {
    const getNoStrParams = link.match(/\$\{[^{}]+(?=\})/g)
    const params = getNoStrParams?.reduce((prev, next) => {
        const getName = next.replace('${', '').split('.')
        const getType = String(getName[0]).toLocaleLowerCase()
        let getValue
        switch (getType) {
        case '_url': {
            getValue = getValueByHref(getName.slice(1, 2))
            break
        }
        case '_cookie': {
            getValue = cookieGet(getName.slice(1, 2))
            break
        }
        case '_window': {
            getValue = getValueByWindow(getName.slice(1, getName.length))
            break
        }
        default:
            getValue = ''
        }
        prev.push(getValue)
        return prev
    }, [])

    return params || link
}

export const getLogParams = (logParams = {}) => {
    const arr = []
    for (let index = 1; index < 11; index++) {
        const val = getTypeValue(logParams[`P${index}`])
        arr.push(Array.isArray(val) ? val.join('') : val)
    }
    return arr
}

// export const activeTemplateCode = {
//     // 裂变
//     '665fc566e4e78db83fbf8982': 'liebian_v2'
// }
